import { StaffGroup } from '@/types/template';

import { backendRequest } from './http-client';

/**
 * Lists staff groups from the backend API for the current tenant.
 *
 * Pass `siteIds` to scope the result to one or more sites (A12 / D43) —
 * the wizard's specific-assignment shift modal narrows the picker to
 * groups that can actually be assigned at the active template sites.
 * Omit `siteIds` to list every group on the realm (the landing's group
 * filter). Forwarded as a comma-separated `?siteIds=` query param;
 * backend's `parseSiteIdsQuery` accepts that shape.
 *
 * @throws Error if the API call fails
 */
export async function listStaffGroups(siteIds?: string[]): Promise<StaffGroup[]> {
  const query = siteIds && siteIds.length > 0 ? `?siteIds=${siteIds.join(',')}` : '';
  return backendRequest<StaffGroup[]>(`/v1/staff-groups${query}`, 'Failed to list staff groups');
}
